import { Swiper } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/pagination";
import { CMCarousel } from './carousel.styles';

const SrcBreakpoints = {
  1024: {
    slidesPerView: 6,
  },
  992: {
    slidesPerView: 5,
  },
  768: {
    slidesPerView: 4,
  },
  575: {
    slidesPerView: 2,
  },
  480: {
    slidesPerView: 2,
  },
  1: {
    slidesPerView: 1,
  },
};

const CMpagination = {
  clickable: true,
  renderBullet: function (index, className) {
    return `<span class="${className}" style="height: 10px; width: 10px; background-color: #a80000"></span>`;
  },
};

const Carousel = ({children, breakpoints, navigation, style, spaceBetween, props}) => {
    return (
        <CMCarousel>
            <Swiper 
              spaceBetween={spaceBetween || 20} 
              effect={'slide'} 
              modules={[Navigation, Pagination]} 
              navigation={navigation} 
              pagination={CMpagination} 
              breakpoints={breakpoints ? breakpoints : SrcBreakpoints}
              style={style} 
              loop={true}
              {...props}
          >
              {children}
          </Swiper>
        </CMCarousel>
    );
}

export default Carousel;